import { defineMessages, IntlShape } from "react-intl";

import { getDisplayName } from "@app/util/ui";

enum ViewMode {
  MAP = "map",
  LIST = "list",
}

const messages = defineMessages<ViewMode>({
  [ViewMode.LIST]: {
    id: "dashboard.viewMode.list",
    defaultMessage: "List",
    description: "List view mode display name",
  },
  [ViewMode.MAP]: {
    id: "dashboard.viewMode.map",
    defaultMessage: "Map",
    description: "Map view mode display name",
  },
});

export const getViewModeDisplayName = (intl: IntlShape, viewMode: ViewMode) =>
  getDisplayName(intl, messages, viewMode, "ViewMode");

export default ViewMode;
